import { useMemo } from 'react';
import { Tooltip } from '@mui/material';

import { DataTable, HandscoreIcon, type TableColumn } from '@/src/ui';
import type { ExamAssignmentDTO } from '../TeacherDashboardDTOs';
import { ReportHeaderStyle, ReportCellStyle, utcToLocal, formatOptions } from '@/src/utils';

interface ExamAssignmentsTableProps {
    data: Array<ExamAssignmentDTO>;
    setShowCompletionStatusReportModal: (val: boolean) => void;
    setSelectedAssignment: (val: ExamAssignmentDTO | null) => void;
}

export default function ExamAssignmentsTable(props: ExamAssignmentsTableProps) {
    const { data, setShowCompletionStatusReportModal, setSelectedAssignment } = props;

    const columns = useMemo<TableColumn[]>(() => {
        return [
            {
                dataKey: 'examName',
                header: 'Name',
                align: 'left',
                allowSort: true,
                emptyValue: '-',
                headerSx: ReportHeaderStyle,
                cellSx: ReportCellStyle,
            },
            {
                dataKey: 'dateRange',
                header: 'Date Range',
                align: 'left',
                width: 100,
                emptyValue: '-',
                headerSx: ReportHeaderStyle,
                cellSx: ReportCellStyle,
                formatter: (row) => {
                    const from = row.fromDate
                        ? utcToLocal(row.fromDate)?.toLocaleString(undefined, formatOptions)
                        : '--';
                    const to = row.toDate
                        ? utcToLocal(row.toDate)?.toLocaleString(undefined, formatOptions)
                        : '--';

                    return `${from} - ${to}`;
                },
            },
            {
                dataKey: 'actions',
                header: 'Actions',
                align: 'left',
                width: 60,
                emptyValue: '-',
                headerSx: ReportHeaderStyle,
                cellSx: ReportCellStyle,
                formatter: (row: ExamAssignmentDTO) => (
                    <Tooltip title="Completion Status Report" arrow>
                        <button
                            className="icon-button"
                            style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                            onClick={() => {
                                setSelectedAssignment(row);
                                setShowCompletionStatusReportModal(true);
                            }}
                        >
                            <HandscoreIcon style={{ width: '28px', height: '28px' }} />
                        </button>
                    </Tooltip>
                ),
            },
        ];
    }, [setSelectedAssignment, setShowCompletionStatusReportModal]);

    return (
        <>
            <DataTable
                data={data}
                columns={columns}
                tableName="Assessments"
                alternatingRowColor
                rowsPerPageInitial={5}
                rowsPerPageList={[5]}
                defaultSortColumn="examName"
                defaultSortDirection="asc"
            />
        </>
    );
}
